import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import financialPlanningImageDesktopWebp from './images/man-reading-tax-documents-desktop.webp';
import financialPlanningImageMobileWebp from './images/man-reading-tax-documents-mobile.webp';
// styles
import { BulletedListStyled } from './styles';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='tax-documents-financial-planning'
      moduleName='financial-planning-module'
      moduleVariant='A'
      disableBottomPadding={false}
      reverseContent={false}
      // content
      subHeadingText={<>How to get your <WidowBlock>tax documents.</WidowBlock></>}
      // column content
      columnContentA={(
        <BulletedListStyled
          bulletType='filledCircle'
          bulletedListData={[
            {
              bulletText: <>
                <Typography
                  weight={500}
                  disableBottomPadding>
                  Enrolled in eDelivery&#63;
                </Typography>
                <Typography disableBottomPadding>
                  You&#39;ll receive an email confirming that your tax forms are ready to download. Once available, you can access all your Northwestern Mutual tax forms in the Documents tab of your online accounts.
                </Typography>
              </>,
            },
            {
              bulletText: <>
                <Typography
                  weight={500}
                  disableBottomPadding>
                  Not enrolled in eDelivery&#63;
                </Typography>
                <Typography disableBottomPadding>
                  Your tax forms will be mailed to you.
                </Typography>
              </>,
            },
            {
              bulletText: <>
                <Typography
                  weight={500}
                  disableBottomPadding>
                  Using TurboTax&#63;
                </Typography>
                <Typography disableBottomPadding>
                  Download your tax forms from the Documents tab of your online accounts or if you receive your forms by mail, copy them. Then upload your tax forms into TurboTax.
                </Typography>
              </>,
            },
            {
              bulletText: <>
                <Typography
                  weight={500}
                  disableBottomPadding>
                  Looking for forms for a closed investment account&#63;
                </Typography>
                <Typography disableBottomPadding>
                  <Link
                    id='tax-documents-financial-planning-tax-forms-link'
                    variant='primaryDeemphasize'
                    linkUrl='http://nmis.netxinvestor.com/'
                    isOutgoingLink>
                    Access your tax forms here
                  </Link>
                  {' '}using your Northwestern Mutual login credentials.
                </Typography>
              </>,
            },
          ]}
          disableBottomPadding
        />
      )}
      // image props
      imageAltText='A man going over his tax documents'
      imageSrcDefault={financialPlanningImageDesktopWebp.toString()}
      imageSrcMobile={financialPlanningImageMobileWebp.toString()}
    />
  );
};

